import Datepicker from '../components/inputs/datepicker';
import TireWarrantyFileInput from '../components/tire-warranty/tire-warranty-file-input';
import Collapsible from '../components/shared/collapsible';
import QuantitySelector from '../components/inputs/quantity-selector';
import Tooltip from '../components/shared/tooltip';
import B2BUnitSwitch from '../components/common/b2bunit-switch';
import AsyncProductData from '../components/product/async-product-data';
import FormSubmitHelper from '../helpers/form-submit-helper';
import Table from '../components/shared/table';
import SlimSelectHelper from '../helpers/slim-select-helper';
import Carousel from '../components/cms/carousel';
import Header from '../components/common/header';
import CategoryCarousel from '../components/cms/category-carousel';
import ResetFilters from '../components/product/reset-filters';
import ExcelExportButton from '../components/shared/excel-export-button';
import FormSubmitConfirmationModal from '../components/shared/form-submit-confirmation-modal';
import PageInfoLightbox from '../components/shared/page-info-lightbox';
import ContextMenu from '../components/shared/context-menu';
import ProductQuantitySelector from '../components/product/product-quantity-selector';

interface PageConfig {
  masterStockRequest?: boolean;
}

export default class Page {

  private readonly header?: Header;

  protected constructor(protected config: PageConfig) {
    if (document.querySelector('header.header')) {
      this.header = new Header();
    }

    Table.initAll();
    SlimSelectHelper.initAll();
    Datepicker.initAll();
    TireWarrantyFileInput.initAll();
    Collapsible.initAll();
    QuantitySelector.initAll();
    Tooltip.initAll();
    B2BUnitSwitch.init();
    FormSubmitHelper.initAll();
    FormSubmitConfirmationModal.initAll();
    if (!config?.masterStockRequest) AsyncProductData.initAll();
    Carousel.initAll();
    CategoryCarousel.initAll();
    ResetFilters.initAll();
    ExcelExportButton.initAll();
    PageInfoLightbox.initAll();
    ContextMenu.initAll();
    ProductQuantitySelector.initAll();
  }

  // eslint-disable-next-line
  init(): void {}

  // eslint-disable-next-line class-methods-use-this
  refresh(): void {
    // No location.reload() because of https://bugzilla.mozilla.org/show_bug.cgi?id=654072
    // eslint-disable-next-line no-self-assign
    window.location.href = window.location.href;
  }
}
